const badgeLostOrReturned = status => ['deleted', 'lost'].includes(status);

const rowStyle = badgeLostOrReturned => {
  return {
    textDecoration: badgeLostOrReturned ? 'line-through' : 'none',
  };
};

export { badgeLostOrReturned, rowStyle };
